import {Component, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {MessageAlertService} from '../../services/message-alert/message-alert.service';

@Component({
  selector: 'app-user-register-how-clinic',
  templateUrl: './user-register-how-clinic.component.html',
  styleUrls: ['./user-register-how-clinic.component.scss']
})
export class UserRegisterHowClinicComponent implements OnInit {
  @ViewChild('form') form: NgForm;
  optionsReason: string[] = [];
  reason;
  constructor(
    public alertService: MessageAlertService,
  ) { }

  ngOnInit(): void {
    this.initValues();
  }

  initValues(): void {
    this.optionsReason = ['Por redes sociales', 'Por un familiar', 'Por folletos'];
  }

  public validate(): boolean {
    this.form.control.markAllAsTouched();
    this.form.control.markAsDirty();
    const valid = this.form.valid;
    if (!valid) {
      this.alertService.createMessage('error', 'Debes completar los datos para seguir');
    }
    return valid;
  }

  public getValue(): string {
    return this.reason;
  }
}
